module.exports = __webpack_public_path__ + "static/media/quiz.0feb2224.png";